<div id="chooseoptionsnew" class="text-start p-3">
  <p class="font-26 fw-bold">Choose Your Options</p>
  <div class="additional-option font-16 pb-4">
    If you change the plan selected, you will need to re-select your Options
  </div>
  <div class="choose-option-card">
    <div
      class="p-card p-3 m-0"
      *ngIf="selectedCover?.selectedPrice?.productType !== 'Basics'"
    >
      <div
        class="col-12 d-md-flex justify-content-between m-0"
      >
        <div class="option-icon">
          <img src="assets/images/w2c/w2c-cancellation.png" />
        </div>
        <div class="col-md-8 option-details">
          <p class="fw-bold ps-2 pe-2">
            Choose Your Cancellation Limit?
            <span class="d-inline-block lightcbg" tabindex="0">
              <ng-container *ngIf="isTooltipVisibleCancellation; else toolTipOnHover">
                <div (click)="toggleTooltip()" class="tooltip-container">
                  <img
                    src="assets/icons/w2c/tooltipinfo.png"
                    class="tooltipc cancellation-tooltip"
                    width="20"
                    tooltipPosition="right"
                  />
                  <ng-container *ngIf="isTooltipVisibleCancellation">
                    <ng-container *ngTemplateOutlet="cancellationTooltip"></ng-container>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #toolTipOnHover>
                <img
                  src="assets/icons/w2c/tooltipinfo.png"
                  class="tooltipc cancellation-tooltip"
                  width="20"
                  [pTooltip]="cancellationTooltip"
                  tooltipPosition="right"
                  tooltipStyleClass="cancellation-tooltip"
                />
              </ng-template>
            </span>
          </p>
          <p class="ps-2 pe-2">
            You can add the amount of cancellation cover that suits. Select an
            amount from the options available, with the limit to apply per adult.
          </p>
          <p class="fw-bold amount ps-2 pe-2 mb-1 d-md-block d-sm-none">
            $ {{ selectedCover?.selectedPrice?.cancellationLimitPremium | number : '1.2-2' }}
          </p>
        </div>
        <div class="col-md-3 option-selection ps-2 pe-2">
          <select
            class="form-select select cancel-amount"
            [(ngModel)]="selectedCancellationValue"
            (change)="onCancellationClick($event)"
          >
            <option
              *ngFor="let cancellation of cancellationList"
              value="{{ cancellation }}"
            >
              {{ cancellation }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12  d-md-none">
        <div class="option-details d-md-none">
          <p class="fw-bold amount ps-2 pe-2 mb-1 mt-3">$ {{ selectedCover?.selectedPrice?.cancellationLimitPremium | number : '1.2-2' }}</p>
        </div>
      </div>
    </div>

    <div
      class="p-card p-3 m-0"
      *ngIf="selectedCover?.selectedPrice?.productType === 'Basics'"
    >
      <div
        class="col-12 d-md-flex justify-content-between m-0"
      >
        <div class="option-icon">
          <img src="assets/images/w2c/w2c-cancellation.png" />
        </div>
        <div class="col-md-8 option-details">
          <p class="fw-bold ps-2 pe-2">
            Choose Your Cancellation Limit?
            <span class="d-inline-block lightcbg" tabindex="0">
              <ng-container *ngIf="isTooltipVisibleCancellation; else toolTipOnHover">
                <div (click)="toggleTooltip()" class="tooltip-container">
                  <img
                    src="assets/icons/w2c/tooltipinfo.png"
                    class="tooltipc cancellation-tooltip"
                    width="20"
                    tooltipPosition="right"
                  />
                  <ng-container *ngIf="isTooltipVisibleCancellation">
                    <ng-container *ngTemplateOutlet="cancellationTooltip"></ng-container>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #toolTipOnHover>
                <img
                  src="assets/icons/w2c/tooltipinfo.png"
                  class="tooltipc cancellation-tooltip"
                  width="20"
                  [pTooltip]="cancellationTooltip"
                  tooltipPosition="right"
                  tooltipStyleClass="cancellation-tooltip"
                />
              </ng-template>
            </span>
          </p>
          <p class="ps-2 pe-2">
            You can add the amount of cancellation cover that suits. Select an
            amount from the options available, with the limit to apply per adult.
          </p>
        </div>
        <div class="col-md-3 option-selection ps-2 pe-2">
          <select class="form-select select cancel-amount" disabled>
            <option>Not Applicable</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- CRUISE -->
  <div
    class="choose-option-card cruise mt-4"
    *ngIf="
      selectedCover?.selectedPrice?.productType !== 'Domestic' &&
      selectedCover?.selectedPrice?.productType !== 'Rental Base' &&
      selectedCover?.selectedPrice?.productType !== 'Cancellation'
    "
  >
    <div
      class="col-12 d-md-flex justify-content-between p-card p-3 m-0"
    >
      <div class="option-icon">
        <img src="assets/images/w2c/w2c-cruise.png" />
      </div>
      <div class="col-md-8 option-details">
        <p class="fw-bold ps-2 pe-2">Going on a Cruise?</p>
        <p class="ps-2 pe-2">
          Our definition of Cruise means an ocean voyage on a commercially
          operated vessel for 2 nights or more. For more information on what
          types of cruises this cover applies to and to assist you in selecting
          the cover that is most appropriate for your cruise, please select the
          FAQ’s link at the top of this page.
        </p>
        <p class="fw-bold ps-2 pe-2 mb-1 d-md-block d-sm-none">
          <span class="cruise-days d-none">Total Days:4 </span>
          <span class="fw-bold amount ps-2 pe-2 mb-1"
            >$ {{ selectedCover?.selectedPrice?.cruisePremium | number : '1.2-2' }}</span
          >
        </p>
      </div>
      <div class="col-md-3 option-selection ps-2 pe-2 text-end">
        <div class="cruise-edit fw-500 text-end mb-2 d-none">
          <img
            src="assets/icons/w2c/edit_calendar.png"
            class="editcalender pe-2"
            width="28"
          />Edit
        </div>
        <div class="cruise-selection d-flex">
          <button
            type="button"
            class="btn btn-lg btn-outline-info px-4 moboptbtn szbtn"
            [ngClass]="{
              'selected-label': selectedCruiseLabel === 'cruise_yes'
            }"
            pButton
            (click)="onRadioCruiseClick($event, 'cruise_yes')"
          >
            Yes
          </button>
          <button
            type="button"
            class="btn btn-lg btn-outline-info px-4 moboptbtn szbtn"
            [ngClass]="{
              'selected-label': selectedCruiseLabel === 'cruise_no'
            }"
            pButton
            [disabled]="isCruise"
            (click)="onRadioCruiseClick($event, 'cruise_no')"
          >
            No
          </button>
        </div>
      </div>

      <div class="col-12  d-md-none">
        <div class="option-details d-md-none">
          <p class="fw-bold amount ps-2 pe-2 mb-1 mt-3">
            $ {{ selectedCover?.selectedPrice?.cruisePremium | number : '1.2-2' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Ski & Winter Sports -->
  <div
    class="choose-option-card cruise mt-4"
    *ngIf="
      isSki &&
      selectedCover?.selectedPrice?.productType !== 'Basics' &&
      selectedCover?.selectedPrice?.productType !== 'Rental Base' &&
      selectedCover?.selectedPrice?.productType !== 'Cancellation'
    "
  >
    <div
      class="col-12 d-md-flex justify-content-between p-card p-3 m-0"
    >
      <div class="option-icon">
        <img src="assets/images/w2c/w2c-ski.png" />
      </div>
      <div class="col-md-8 option-details">
        <p class="fw-bold ps-2 pe-2">Ski & Winter Sports?</p>
        <p class="ps-2 pe-2">
          You must purchase the Ski and Winter Sports option in order to be
          covered for Overseas Medical and Hospital expenses that are incurred
          following an accident that takes place whilst participating in Skiing
          or Winter Sports. Not all winter sports are covered and these are
          explained in the PDS.
        </p>
        <p class="fw-bold ps-2 pe-2 mb-1 d-md-block d-sm-none">
          <span class="cruise-days d-none">Total Days:4 </span>
          <span class="fw-bold amount ps-2 pe-2 mb-1"
            >$ {{ selectedCover?.selectedPrice?.skiingPremium | number : '1.2-2'}}</span
          >
        </p>
      </div>
      <div class="col-md-3 option-selection ps-2 pe-2 text-end">
        <div class="ski-selection d-flex">
          <button
            type="button"
            class="btn btn-lg btn-outline-info px-4 moboptbtn szbtn"
            [ngClass]="{
              'selected-label': selectedSportsLabel === 'sports_yes'
            }"
            pButton
            (click)="onRadioSportsClick($event, 'sports_yes')"
          >
            Yes
          </button>
          <button
            type="button"
            class="btn btn-lg btn-outline-info px-4 moboptbtn szbtn"
            [ngClass]="{
              'selected-label': selectedSportsLabel === 'sports_no'
            }"
            pButton
            (click)="onRadioSportsClick($event, 'sports_no')"
          >
            No
          </button>
        </div>
      </div>

      <div class="col-12  d-md-none">
        <div class="option-details d-md-none">
          <p class="fw-bold amount ps-2 pe-2 mb-1 mt-3">
            $ {{ selectedCover?.selectedPrice?.skiingPremium | number : '1.2-2'}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #skiWinterTooltip>
  <div
    [ngClass]="
      isTooltipVisibleSki ? { 'tooltip-content': true, show: true } : ''
    "
    *ngIf="selectedCover?.selectedPrice?.productType !== 'Domestic'"
  >
    {{ skiTooltipMessage }}
  </div>
  <div
    [ngClass]="
      isTooltipVisibleSki ? { 'tooltip-content': true, show: true } : ''
    "
    *ngIf="selectedCover?.selectedPrice?.productType === 'Domestic'"
  >
    You must purchase the Ski and Winter Sports option to be covered for
    expenses related to snow ski equipment hire, ski pack, bad weather,
    avalanche, and lift pass. However, no medical or hospital expenses are
    covered. Please note that not all Winter Sports are covered, these are
    explained in the PDS.
  </div>
</ng-template>

<ng-template #cruiseTooltip>
  <div
    [ngClass]="
      isTooltipVisibleCruise ? { 'tooltip-content': true, show: true } : ''
    "
  >
    For more information on what types of cruises this cover applies to and to
    assist you in selecting the cover that is appropriate for your cruise,
    please select the Cruise page link from the Travel Insurance list at the top
    of this page.
  </div>
</ng-template>

<ng-template #cancellationTooltip>
  <div
    [ngClass]="
      isTooltipVisibleCancellation
        ? { 'tooltip-content': true, show: true }
        : { show: true }
    "
  >
    The maximum cancellation benefit for claims related to COVID-19 is limited
    and may be lower than the overall cancellation limit you select. Please
    refer to the PDS for the limits available based on the plan chosen.
  </div>
</ng-template>
